import { globalStyle, style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const contentWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.l,
  padding: vars.space.l,
  paddingTop: 0,
  textAlign: "center",
  color: vars.colors.onSurface,
});

export const crestWrapper = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: vars.space.s,
});

export const adobePlaceholderImage = style({
  width: "80%",
  height: "auto",
});

export const descriptionList = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
  textAlign: "start",
});

globalStyle(`${descriptionList} li`, {
  marginInlineStart: vars.space.m,
  listStyleType: "disc",
});

export const buttonGroup = style({
  display: "flex",
  gap: vars.space.xs,
});

export const crestActionsWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});
